(function() {
  $(document).ready(function() {
    'use strict';
    $('#datatable').dataTable();
  });

}).call(this);
